module.exports = __webpack_public_path__ + "assets/images/hemoglobin_r.4ce35418.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/hemoglobin_r.png
// module id = 733
// module chunks = 1